export default __webpack_public_path__ + "static/media/wallet_inactive.6e6fb779.svg";